(function () {
  if (window.__lazyVideoInit) return;
  window.__lazyVideoInit = true;
  function play(video) {
    var p = video.play();
    if (p && p.catch) p.catch(function () { video.dataset.autoplayBlocked = '1'; });
  }
  function load(video) {
    if (video.dataset.lazyLoaded) return;
    video.querySelectorAll('source[data-src]').forEach(function (source) {
      source.src = source.dataset.src;
      source.removeAttribute('data-src');
    });
    video.load();
    video.dataset.lazyLoaded = '1';
  }
  if (!('IntersectionObserver' in window)) {
    document.querySelectorAll('video[data-lazy-video]').forEach(function (v) { load(v); play(v); });
    return;
  }
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      var video = entry.target;
      // a copy hidden by CSS (mobile vs desktop) has no box: never download it
      if (entry.isIntersecting && video.offsetParent !== null) {
        load(video);
        play(video);
      } else if (!video.paused) {
        video.pause();
      }
    });
  }, { rootMargin: '300px 0px' });
  function observeAll(root) {
    (root || document).querySelectorAll('video[data-lazy-video]:not([data-lazy-observed])').forEach(function (v) {
      v.dataset.lazyObserved = '1';
      observer.observe(v);
    });
  }
  observeAll();
  // theme editor and re-rendered sections
  document.addEventListener('shopify:section:load', function (e) { observeAll(e.target); });
  // iOS low-power mode blocks autoplay: retry on the first touch
  ['touchstart', 'click', 'keydown'].forEach(function (evt) {
    document.addEventListener(evt, function () {
      document.querySelectorAll('video[data-autoplay-blocked="1"]').forEach(function (v) {
        delete v.dataset.autoplayBlocked;
        play(v);
      });
    }, { passive: true, once: true });
  });
})();